import { NextgenImage, Theme } from '@nextgen-web-framework/all';
import { FC } from 'react';
import styles from './CustomTag.module.scss';
import { CustomTagPropsTypes } from './types/propsTypes';

const CustomTag: FC<CustomTagPropsTypes> = (props) => {
  const { text, theme = Theme.SUCCESS, height, width, ...imageProps } = props;
  return (
    <div className={`${styles['tag']} ${styles[theme]}`} data-testid="custom-tag-container">
      <div className={styles['icon']} style={{ height: height, width: width }}>
        <NextgenImage {...imageProps} />
      </div>
      <p className={styles['title']}>{text}</p>
    </div>
  );
};

export default CustomTag;
export type { CustomTagPropsTypes };
